import axios from "axios";


export const postTopLevelGroup = async (data) => {
    const response = await axios.post("api/TaskIncidentCategoriesToplevelGroups", data);
    const result = response.data;
    return result;
}

export const patchTopLevelGroup = async (data) => {
    const response = await axios.patch("api/TaskIncidentCategoriesToplevelGroups", data);
    const result = response.data;
    return result;
}

export const getTopLevelGroups = async (companyId) => {
    const response = await axios.get(`api/TaskIncidentCategoriesToplevelGroups/${companyId}`);
    const result = response.data;
    return result;
}

export const deleteTopLevelGroup = async (id) => {
    const response = await axios.delete(`api/TaskIncidentCategoriesToplevelGroups/${id}`);
    const result = response.data;
    return result;
}